<template>
    <div class="modal fade" id="modalClonarCategoria" tabindex = "-1"
        role="dialog" aria-labelledby="modalClonarCategoriaLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >
                        Clonar Categorias y Subcategorias
                    </h5>
                    <button class="close" type="button" @click="cerrarModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>                    
                    <!---------------------BODY---------------------------------->
                <div class="modal-body ">   
                    <div class="row mt-2 border border-3 rounded py-3">
                        <div class="text-center rounded border border-success pt-2 col-12" >
                          <h5>  
                            <i class="fa fa-user fa-lg text-success"></i>
                            {{ pickeador.username }}
                          </h5>              
                        </div>     
                        <div class="col-12 col-md-12 mt-3">
                            <label>Transferir tareas a: </label>                                    
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text text-success"><i class="fa fa-user fa-lg"></i></span>
                                </div>                                     
                                <v-select 
                                    label="name"                                            
                                    v-model="current.pickeadorNuevo"
                                    class="form-control px-0 py-0" 
                                    :filterable="false"
                                    :options="users.results"
                                    @search="onSearch"
                                    @onChange = "onChangePickNuevo"                                       
                                    :disabled="false"
                                    :clearable="true" 
                                    >    
                                    <template slot="no-options">usuarios...</template>                                    
                                    <template slot="option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option !=null ? option.username : '' }} 
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option !=null ? option.username : ''}} 
                                        </div>
                                    </template>
                                </v-select>                                   
                            </div>
                        </div>                                
                        <div class="col-12 col-md-6 mt-3">
                            <label>Fecha Inicio {{ current.pickeadorNuevo.username ? " de: " : "" }}<span class="text-success">{{ current.pickeadorNuevo.username ? current.pickeadorNuevo.username : "" }} </span></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                                <input type="date" class="form-control" v-model="fecha_inicio">
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mt-3">
                            <label>Fecha Fin {{ current.pickeadorNuevo.username ? " de: " : "" }} <span class="text-success">{{ current.pickeadorNuevo.username ? current.pickeadorNuevo.username : "" }} </span>  </label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                                <input type="date" class="form-control" v-model="fecha_fin">
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <label>&nbsp;</label>                                
                            <div class="input-group">
                                <button class="btn btn-success btn-block" style="height:34px" 
                                @click="clonarTareas" :disabled="!current.pickeadorNuevo || datos_completos.length==0">
                                    <i class="fas fa-clone"></i> &nbsp; Clonar Tareas
                                </button>
                            </div>                                    
                        </div>  
                    </div>
                </div>
            </div>
        </div>     
    </div>      
</template>

<script>    
    import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
    import { mapGetters } from "vuex";
    import Notifications from "@/notifications/notifications";
    import DynamicService from "@/services/commons/DynamicService";
    import PaginationComponent from "@/components/utils/PaginationComponent";
    import CategoriasUsuarioEdicionComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CategoriasUsuarioEdicionComponent";

    export default {
        props:{
            pickeador:{
                type: Object,
                required: true,
                default: null
            },
            datos_completos:{
                type: Array,
                required:true,
                default:[]
            }
        },
        components:{            
            UsuariosSelectComponent,
            PaginationComponent,
            CategoriasUsuarioEdicionComponent
        },
        data(){
            return {
                //clickeados, arreglos, objetos
                currentPage:1,
                current:{
                    pickeadorNuevo:[],
                    pickeadorReferencia:[],                                   
                },
                userNuevoSelected:"",
                userAntiguoSelected:"", 
                data:[], 
                data_tabla: [],               
                checked:[],    
                existenTareas:false,
                fecha_inicio:"",
                fecha_fin:"",                
                animarTitulo: false,  
                animarSalida: false,
                mostrarEncabezado: false,
                titulo:"",
                localPickeador: {}
            }
        },
        computed:{
            ...mapGetters( "accounts",["users"])
        },
        watch: {          
            /**
             *Observa cuando se da clic en "x" de select pickeadorNuevo
             para limpiarlo
             */
            "current.pickeadorNuevo"(val){                 
                //No hay pickeador seleccionado               
                if(!val && val == null){   
                    //animación de salida
                    this.animarTitulo = false
                    this.animarSalida = true

                    setTimeout(()=>{
                        this.animarSalida=false;
                        this.mostrarEncabezado=false;                       
                    }, 500);
                    this.current.pickeadorNuevo="";
                    return;
                }                
                if(val){                    
                    //validacion los dos pickeadores deben ser diferentes
                    if(this.current.pickeadorNuevo.username == this.current.pickeadorReferencia.username){
                        Notifications.alert.error("No se puede clonar tareas al mismo usuario","Seleccione un usuario diferente");                         
                        this.current.pickeadorNuevo="";   
                        return;                  
                    }   
                    this.titulo = ""
                    this.titulo = this.current.pickeadorNuevo.username;
                    this.mostrarEncabezado = true;
                    this.animarSalida = false;
                    this.animarTitulo = false;

                    this.$nextTick(()=>{
                    setTimeout(()=>{
                        this.animarTitulo = true;
                    },10);                   
                });

                }
                if(val && val.is_active==false){
                    Notifications.alert.error("Usuario seleccionado inactivo","Seleccione un usuario activo");
                    this.current.pickeadorNuevo="";
                }   
            },
              /**
             *Observa cuando se da clic en "x" de select pickeadorReferencia
             para limpiarlo y verifica si hay datos en la tabla de tareas            
             */
             "current.pickeadorReferencia"(val){  
                if(!val){
                    this.current.pickeadorReferencia="";
                    self.existenTareas=false;     
                }
                if(val){
                    if(this.current.pickeadorNuevo.username == this.current.pickeadorReferencia.username){
                        Notifications.alert.error("No se puede clonar tareas al mismo usuario","Seleccione un usuario diferente");                          
                        this.current.pickeadorReferencia="";   
                        return;                  
                    }            
                }                
            },   
            pickeador(val){   
                if(!val|| Object.keys(val).length === 0){                  
                    return;
                }
                if(val && Object.keys(val).length>0){                  
                    this.localPickeador = val            
                }   
            },   
            /**
             * Copia de pickeador, para no mutar prop directamente */  
            localPickeador:{
                handler(val){           
                    //Primera llamada para obtener categorias paginadas para tabla detalle
                    if(!val || Object.keys(val).length === 0){                     
                        return;
                    }
                    if(val && Object.keys(val).length > 0 ){                   
                        this.obtenerCategoriasSubcategorias({
                            page: 1,
                            pickeador_referencia: val.id,
                            sin_paginacion:false
                        })
                        //Segunda llamada para obtener categorias sin paginar (datos_completos)
                        this.obtenerCategoriasSubcategorias({
                            page: 1,
                            pickeador_referencia: val.id,
                            sin_paginacion:true
                        }) 
                    }
                },
                deep:true,
                immediate:true                   
            },               
        },
        mounted(){
            let self= this;    
            this.$store.dispatch("accounts/users",{
                page: 1
            })
            self.obtenerUsuarios();        
        },
      
        methods:{
            /*
            Metodos para busqueda y seleccion de usuario pickeador nuevo
            y usuario pickeador referencia
            */
            obtenerUsuarios(){
                let self= this;               
            },
            onChangePickNuevo(clickeado){            
            },
            onChangePickReferencia(clickeado){                 
            },
            onSearch(search,loading){
                loading(true);
                this.search(loading,search,this);
            },
            search: _.debounce((loading,search,vm) => {
                if(search=="" || search == null){
                    loading(false);
                    return;
                }
                let that=this;
                vm.$store.dispatch("accounts/users",{
                    activo:true,
                    page:1,
                    "filter[search]": search,
                });
                loading(false);
            },350),
            /****************************************************** */       
            obtenerCategoriasSubcategorias(params){
                let self=this;        
                DynamicService.getActionList(
                    "wms",
                    "asignar-tarea-usuario", 
                    "get_tareas_usuario", 
                    params)
                .then((response) =>{                    
                    if(params.sin_paginacion){   
                    }else{                        
                        self.data = response.data;
                        self.data_tabla = response.data.results                        
                        let contadorOK= self.data_tabla.filter(res => res.estatus==true).length                        
                        if(contadorOK==0){
                            Notifications.alert.error("Usuario sin tareas activas","No hay tareas para clonar")                       
                            self.current.pickeadorReferencia="";
                            self.existenTareas=false;
                            return
                        }else{
                            self.existenTareas=true;       
                        }    
                    }                                  
                }).catch((error)=>{
                    Notification.alert.error("Error",error)
                })
            },        
            async clonarTareas(){               
                let self= this;  
                console.log("pickeador nuevo: ", self.current.pickeadorNuevo)
                if(Object.keys(self.current.pickeadorNuevo).length==0){
                    Notifications.alert.error("Pickeador nuevo sin seleccionar","Complete la seleccion");
                    return;
                }
             
                //Validaciones de fecha y formato de fecha               
                if(self.fecha_inicio=="" ){
                    Notifications.alert.error("Fecha Inicio","Ingrese la fecha de inicio");
                    return;
                }
                if(self.fecha_fin==""){
                    Notifications.alert.error("Fecha Fin","Ingrese la fecha final");
                    return;
                }       
                if(self.fecha_inicio>self.fecha_fin){
                    Notifications.alert.error("Fechas invalidas","La fecha de inicio debe ser menor a la fecha de fin");
                    return;
                } 
                
                self.fecha_inicio_format = moment(
                    self.fecha_inicio,
                    "YYYY-MM-DD"
                    ).format("YYYY-MM-DDTHH:mm:ss.SSS");
                self.fecha_fin_format  = moment(
                    self.fecha_fin,
                    "YYYY-MM-DD"
                    ).format("YYYY-MM-DDTHH:mm:ss.SSS");
       
                let params= {
                    pickeador_referencia: self.pickeador.id,
                    tareas:self.datos_completos,
                    pickeador: self.current.pickeadorNuevo.id,
                    fecha_inicio: self.fecha_inicio_format,
                    fecha_fin: self.fecha_fin_format,
                }         
            
                Notifications.alert.confirm(
                    "Clonar categorias y subcategorías",
                    "Se inactivarán las categorías de: "+self.pickeador.username+". ¿Está seguro?",
                    "",
                    function(){
                        DynamicService.postActionList("wms", "asignar-tarea-usuario", "clonar_tareas_nuevo_pickeador", params)
                        .then((response) =>{
                    
                            //cuenta tareas clonadas exitosamente y las fallidas
                            let contadorOK = response.data.resultados.filter(res => res.status == 'ok').length;                    
                    
                            Notifications.alert.success(
                                "Categorías y Subcategorías transferidas exitosamente",
                                "Categorias/Subcategorias transferidas: ["+contadorOK+"].  "
                                +" Puede agregar o eliminar categorias y subcategorias al nuevo usuario ");
                    
                            self.$emit("refreshData", self.current.pickeadorNuevo.id)   
                            self.current = {}                   
                            self.localPickeador = {} 
                            self.cerrarModal()              
                        }).catch((error)=>{
                            Notifications.alert.error("Error al transferir categorías y subcategorías","Error "+error);
                        }) 
                    }

                )              
            },  
            onPageChange(page){           
                this.currentPage = page;
                this.obtenerCategoriasSubcategorias({
                    page: this.currentPage,
                    pickeador_referencia: this.current.pickeadorReferencia.id,
                    sin_paginacion:false,
                });
            },
            cerrarModal(){        
                let self=this;
                // self.refresh()
                self.mostrarModal = false
                self.existeRegistro= false
                self.$emit("cerrarModalClonar")                            
            },       
        }   
    }

</script>

<style>
    .titulo-animado {
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.5s ease-out;
    }

    .titulo-animado-activo{
        opacity: 1;
        transform: translateY(0);
    }

    .titulo-animado-inactivo{
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.5s ease-out;
    }
    
</style>